import * as Sentry from '@sentry/vue';
import { v4 as uuid4 } from 'uuid';
import { App } from 'vue';
import { Router } from 'vue-router';

const ANONYMOUS_ID_KEY = 'anonymousId';
const IGNORED_ERRORS: (string | RegExp)[] = [
	'NavigationDuplicated',
	/Avoided redundant navigation/,
];

const getAnonymousID = (): string => {
	const anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY);

	if (anonymousId) {
		return anonymousId;
	}

	const newId = uuid4();
	localStorage.setItem(ANONYMOUS_ID_KEY, newId);

	return newId;
};

const beforeSendHandler = (event: Sentry.ErrorEvent): Sentry.ErrorEvent => {
	const urlHash = window.location.hash || '/';
	const actionMatch = new RegExp(/[?&]action=([^&]+)/).exec(urlHash);
	const action = actionMatch ? actionMatch[1] : undefined;

	event.tags = {
		...event.tags,
		'url.hash': urlHash,
		'url.action': action,
	};

	return event;
};

export const initSentry = (app: App, router: Router): void => {
	Sentry.init({
		app,
		environment: import.meta.env.VUE_APP_SENTRY_ENV,
		dsn: `${import.meta.env.VUE_APP_SENTRY_DSN}`,
		release:
			import.meta.env.VUE_APP_TAG_NAME || import.meta.env.VUE_APP_VERSION,
		maxBreadcrumbs: 150,
		ignoreErrors: IGNORED_ERRORS,
		tracesSampleRate: 0.05,
		replaysSessionSampleRate: 0.01,
		replaysOnErrorSampleRate: 0.01,
		integrations: [
			Sentry.linkedErrorsIntegration(),
			Sentry.browserTracingIntegration({ router }),
			Sentry.replayIntegration(),
		],
		initialScope: {
			user: {
				id: getAnonymousID(),
			},
		},
		beforeSend: beforeSendHandler,
	});
};
